import { type ReactElement } from 'react'
import { createFileRoute, useLocation } from '@tanstack/react-router'
import { useRedirect } from '@hooks'
import { NestedNavigation } from '@components'
import { useSettingsRoutes } from '../../components/appShell/useSettingsRoutes'

function Settings(): ReactElement {
  const routes = useSettingsRoutes()

  const location = useLocation()
  const isRootSettingRoute = location.pathname === '/settings'
  const shouldRedirect = isRootSettingRoute
  useRedirect('/settings/company', shouldRedirect)

  return <NestedNavigation sectionLabel='Settings' routes={routes} />
}

export const Route = createFileRoute('/settings')({
  component: Settings,
})
